import type { ProfanityLevel } from "../state";

export interface ProfanityStep {
  level: ProfanityLevel;
  label: string;
}

export const PROFANITY_STEPS: ProfanityStep[] = [
  { level: 0, label: "Polite" },
  { level: 1, label: "Spicy" },
  { level: 2, label: "F**ked" },
];

// The daily punchline, sub-line and headline come from engine.ts, which
// fills the templates in bank.ts (plus packs.ts) with a fresh combination
// each day. See docs/COPY.md for how to seed more.

export const SUB = "As of this current moment there are exactly, precisely and unavoidably:";

/**
 * The "event reached" state isn't in the design's scope (flagged in the
 * handoff as not yet designed) — this is a minimal placeholder so the app
 * doesn't show a broken/negative countdown once the date passes. It still
 * follows the same per-level voice as the rest of the copy, though,
 * rather than flattening to one neutral line regardless of the dial.
 */
export function getReachedHeadline(personName: string, level: ProfanityLevel = 1): string {
  const name = personName?.trim();
  const HEADLINES: Record<ProfanityLevel, (n: string) => string> = {
    0: (n) => (n ? `It's here, ${n}. Off you pop.` : "It's here. Off you pop."),
    1: (n) => (n ? `It's here, ${n}. Go on then.` : "It's here. Go on then."),
    2: (n) => (n ? `It's here, ${n}, ya legend. Get in there.` : "It's here, ya legend. Get in there."),
  };
  return HEADLINES[level](name ?? "");
}

export function getReachedPunchline(eventName: string, level: ProfanityLevel = 1): string {
  const name = eventName || "it";
  const PUNCHLINES: Record<ProfanityLevel, string> = {
    0: `Whatever ${name} was, it's arrived. No more waiting about.`,
    1: `Whatever ${name} was, it is now. No more counting.`,
    2: `Whatever the bloody hell ${name} was, it's here. No more counting, no more bollocks.`,
  };
  return PUNCHLINES[level];
}
